(function () {
    VjsAdmin.extend = function (Parent, extObject) {
        function Child(...args) {
            Child.parent.constructor.apply(this, args);
            if (this.construct) {
                this.construct(args[0]);
            }
        }
        Child.prototype = inherit(Parent.prototype);
        Child.prototype.constructor = Child;
        Child.parent = Parent.prototype;
        const child = extendHelper(Child, extObject);
        return child;
    };

    function extendHelper(Child, extObject) {
        Object.keys(extObject).forEach((key) => {
            Child.prototype[key] = extObject[key];
        });
        return Child;
    }

    function inherit(proto) {
        function F() {}
        F.prototype = proto;
        return new F();
    }
}());
